// extracted by mini-css-extract-plugin
export var collapsedSummary = "_jt-0";